import { TextField } from "../../../../utils/form";

const Name = ({ form: { control } }) => 
  <TextField control={control} name="name" label="Nombre" variant="outlined" required style={{ width: "100%" }} />

export default Name;